(function() {
  'use strict';

  // ログインページかどうかを確認
  if (!isLoginPage()) {
    return;
  }

  // ページが完全に読み込まれた後に実行
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      addFanclubSection();
      setupLoginRedirect();
    }, 1000); // 1秒待ってからファンクラブセクションを追加
  });

  function isLoginPage() {
    return window.location.pathname.includes('/account/login') || 
           window.location.pathname.includes('/authentication/');
  }

  // ファンクラブセクションを追加
  function addFanclubSection() {
    const loginMain = document.querySelector('.login-main');
    if (!loginMain) {
      console.log('Login main not found, trying alternative selectors');
      // 代替セレクタを試す
      const alternatives = ['.login-card', '.login-wrapper', 'main'];
      for (const selector of alternatives) {
        const element = document.querySelector(selector);
        if (element) {
          addFanclubToElement(element);
          break;
        }
      }
      return;
    }

    addFanclubToElement(loginMain);
  }

  function addFanclubToElement(container) {
    // 既に追加されているかチェック
    if (container.querySelector('#fanclub-section')) {
      return;
    }

    // ファンクラブセクションのHTML
    const fanclubHTML = createFanclubHTML();
    
    // スタイルを追加
    addFanclubStyles();
    
    // コンテンツを追加
    container.insertAdjacentHTML('beforeend', fanclubHTML);

    // イベントリスナーを設定
    setupFanclubEvents();
  }

  function createFanclubHTML() {
    return `
      <div id="fanclub-section" class="fanclub-login-section">
        <div class="fanclub-banner">
          <div class="fanclub-banner__content">
            <h3 class="fanclub-banner__title">🌟 ROMANsファンクラブ</h3>
            <p class="fanclub-banner__subtitle">限定コンテンツと特典をお楽しみください</p>
            
            <div class="fanclub-benefits">
              <div class="benefit-item">
                <span class="benefit-icon">🎵</span>
                <span class="benefit-text">新曲・アルバム情報をいち早く</span>
              </div>
              <div class="benefit-item">
                <span class="benefit-icon">📧</span>
                <span class="benefit-text">最新情報の優先配信</span>
              </div>
              <div class="benefit-item">
                <span class="benefit-icon">🎪</span>
                <span class="benefit-text">イベント情報の先行案内</span>
              </div>
              <div class="benefit-item">
                <span class="benefit-icon">👥</span>
                <span class="benefit-text">メンバーの近況・限定コンテンツ</span>
              </div>
              <div class="benefit-item">
                <span class="benefit-icon">🎁</span>
                <span class="benefit-text">特別キャンペーン・プレゼント</span>
              </div>
            </div>

            <div class="fanclub-cta">
              <p class="fanclub-cta__text">まだアカウントをお持ちでない方は</p>
              <a href="/account/register" class="fanclub-register-btn">
                <span class="btn-gradient"></span>
                <span class="btn-content">
                  <span class="btn-icon">👑</span>
                  <span class="btn-text">ファンクラブに登録</span>
                </span>
              </a>
              <p class="fanclub-note">※登録は無料です</p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function addFanclubStyles() {
    // 既にスタイルが追加されているかチェック
    if (document.querySelector('#fanclub-login-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'fanclub-login-styles';
    style.textContent = `
      .fanclub-login-section {
        margin: 2rem 0;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
      }

      .fanclub-banner {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 20px;
        padding: 2rem;
        color: white;
        position: relative;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        animation: fadeInUp 0.6s ease-out;
      }

      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .fanclub-banner::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%);
        animation: shimmer 3s ease-in-out infinite;
        pointer-events: none;
      }

      @keyframes shimmer {
        0%, 100% { transform: translateX(-100%); }
        50% { transform: translateX(100%); }
      }

      .fanclub-banner__content {
        position: relative;
        z-index: 1;
      }

      .fanclub-banner__title {
        font-size: 1.8rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        text-align: center;
        text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
      }

      .fanclub-banner__subtitle {
        text-align: center;
        margin-bottom: 1.5rem;
        opacity: 0.9;
        font-size: 1.1rem;
      }

      .fanclub-benefits {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1rem;
        margin-bottom: 2rem;
      }

      .benefit-item {
        display: flex;
        align-items: center;
        background: rgba(255,255,255,0.1);
        backdrop-filter: blur(10px);
        padding: 1rem;
        border-radius: 10px;
        border: 1px solid rgba(255,255,255,0.2);
        transition: all 0.3s ease;
      }

      .benefit-item:hover {
        background: rgba(255,255,255,0.2);
        transform: translateY(-2px);
      }

      .benefit-icon {
        font-size: 1.5rem;
        margin-right: 1rem;
        flex-shrink: 0;
      }

      .benefit-text {
        font-size: 0.95rem;
        font-weight: 500;
      }

      .fanclub-cta {
        text-align: center;
        padding-top: 1rem;
        border-top: 1px solid rgba(255,255,255,0.2);
      }

      .fanclub-cta__text {
        margin-bottom: 1rem;
        font-size: 1.1rem;
      }

      .fanclub-register-btn {
        position: relative;
        display: inline-block;
        padding: 0;
        border: none;
        border-radius: 50px;
        text-decoration: none;
        overflow: hidden;
        transition: all 0.3s ease;
        box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
      }

      .fanclub-register-btn:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 35px rgba(255, 107, 53, 0.4);
      }

      .btn-gradient {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, #ff6b35 0%, #ff8e53 100%);
        border-radius: inherit;
      }

      .btn-content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 30px;
        color: white;
        font-weight: 600;
        font-size: 1.1rem;
        z-index: 1;
      }

      .btn-icon {
        margin-right: 0.5rem;
        font-size: 1.2rem;
        animation: bounce 2s infinite;
      }

      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
        40% { transform: translateY(-5px); }
        60% { transform: translateY(-3px); }
      }

      .fanclub-note {
        margin-top: 1rem;
        font-size: 0.9rem;
        opacity: 0.8;
      }

      @media screen and (max-width: 768px) {
        .fanclub-login-section {
          margin: 1rem;
        }

        .fanclub-banner {
          padding: 1.5rem;
        }

        .fanclub-banner__title {
          font-size: 1.5rem;
        }

        .fanclub-benefits {
          grid-template-columns: 1fr;
          gap: 0.8rem;
        }

        .benefit-item {
          padding: 0.8rem;
        }

        .benefit-text {
          font-size: 0.9rem;
        }

        .btn-content {
          padding: 12px 25px;
          font-size: 1rem;
        }
      }

      /* ダークモード対応 */
      @media (prefers-color-scheme: dark) {
        .fanclub-banner {
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
        }
      }
    `;

    document.head.appendChild(style);
  }

  function setupFanclubEvents() {
    const registerBtn = document.querySelector('.fanclub-register-btn');
    if (registerBtn) {
      registerBtn.addEventListener('click', function(e) {
        // トラッキングイベント（もしあれば）
        if (typeof gtag !== 'undefined') {
          gtag('event', 'fanclub_register_click', {
            'event_category': 'engagement',
            'event_label': 'login_page_banner'
          });
        }
      });
    }
  }

  // ログイン成功後のリダイレクト設定
  function setupLoginRedirect() {
    // Shop Payログインボタンの監視
    observeShopPayLogin();
    
    // 従来のメールログインフォームの監視
    observeEmailLogin();

    // URLの変化を監視
    observeURLChanges();
  }

  function observeShopPayLogin() {
    const shopLoginButton = document.querySelector('shop-login-button');
    if (shopLoginButton) {
      // Shop Payログインの成功を監視
      shopLoginButton.addEventListener('success', function() {
        console.log('Shop Pay login success detected');
        redirectToFanclubOnboarding();
      });

      shopLoginButton.addEventListener('error', function(e) {
        console.log('Shop Pay login error:', e);
      });
    }
  }

  function observeEmailLogin() {
    const form = document.querySelector('#captcha_form');
    if (form) {
      const originalSubmit = form.submit;
      form.submit = function() {
        console.log('Email login form submitted');
        originalSubmit.call(this);
        setTimeout(() => {
          checkLoginSuccess();
        }, 2000);
      };

      form.addEventListener('submit', function(e) {
        console.log('Email login form submit event');
        setTimeout(() => {
          checkLoginSuccess();
        }, 2000);
      });
    }
  }

  function observeURLChanges() {
    let currentURL = window.location.href;
    const checkURL = setInterval(() => {
      if (window.location.href !== currentURL) {
        currentURL = window.location.href;
        if (currentURL.includes('/account') && !currentURL.includes('/login')) {
          console.log('URL changed to account page');
          clearInterval(checkURL);
          redirectToFanclubOnboarding();
        }
      }
    }, 1000);

    // 30秒後にチェックを停止
    setTimeout(() => {
      clearInterval(checkURL);
    }, 30000);
  }

  function checkLoginSuccess() {
    // ログイン成功を確認するための方法
    const checkInterval = setInterval(() => {
      // ページのタイトルやURLの変化をチェック
      if (window.location.pathname.includes('/account') && 
          !window.location.pathname.includes('/login') &&
          !window.location.pathname.includes('/authentication')) {
        console.log('Login success detected via URL change');
        clearInterval(checkInterval);
        redirectToFanclubOnboarding();
      }

      // ページ内容の変化をチェック
      const successIndicators = [
        '.account-dashboard',
        '.customer-account',
        '[data-account-page]'
      ];

      for (const selector of successIndicators) {
        if (document.querySelector(selector)) {
          console.log('Login success detected via page content');
          clearInterval(checkInterval);
          redirectToFanclubOnboarding();
          return;
        }
      }
    }, 1000);

    // 15秒後にチェックを停止
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 15000);
  }

  function redirectToFanclubOnboarding() {
    console.log('Checking fanclub status before redirect');
    
    // ファンクラブ情報が未登録の場合のみリダイレクト
    checkFanclubStatus()
      .then(isRegistered => {
        console.log('Fanclub status:', isRegistered ? 'registered' : 'not registered');
        if (!isRegistered) {
          console.log('Redirecting to fanclub onboarding');
          // フラグを設定してリダイレクト
          sessionStorage.setItem('fanclub_redirect', 'true');
          window.location.href = '/pages/fanclub-onboarding';
        } else {
          console.log('User already registered, staying on account page');
        }
      })
      .catch(error => {
        console.error('Error checking fanclub status:', error);
        // エラーの場合もオンボーディングページへ
        sessionStorage.setItem('fanclub_redirect', 'true');
        window.location.href = '/pages/fanclub-onboarding';
      });
  }

  async function checkFanclubStatus() {
    try {
      // LocalStorageでファンクラブ情報の存在確認（フォールバック）
      const localData = localStorage.getItem('fanclub_member_data');
      if (localData) {
        const memberData = JSON.parse(localData);
        return memberData && memberData.fanclub_member;
      }

      // セッションストレージで確認
      const sessionData = sessionStorage.getItem('fanclub_status');
      if (sessionData === 'registered') {
        return true;
      }

      // Cookieで確認
      const cookies = document.cookie.split('; ');
      const fanclubCookie = cookies.find(row => row.startsWith('fanclub_member='));
      if (fanclubCookie) {
        return fanclubCookie.split('=')[1] === 'true';
      }

      return false;
    } catch (error) {
      console.error('ファンクラブ情報の確認に失敗:', error);
      return false;
    }
  }

  // デバッグ用
  window.fanclubLoginDebug = {
    addFanclubSection,
    checkLoginSuccess,
    redirectToFanclubOnboarding,
    checkFanclubStatus
  };

})();